import { render, staticRenderFns } from "./after-sale-detail.vue?vue&type=template&id=475f6ac2&scoped=true&"
import script from "./after-sale-detail.vue?vue&type=script&lang=js&"
export * from "./after-sale-detail.vue?vue&type=script&lang=js&"
import style0 from "./after-sale-detail.vue?vue&type=style&index=0&id=475f6ac2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475f6ac2",
  null
  
)

export default component.exports